/**
 * Full-page loading indicator with optional message.
 *
 * Replaces the repetitive pattern of:
 *   <Box sx={{ textAlign: "center", py: 8 }}>
 *     <CircularProgress />
 *     <Typography>Loading...</Typography>
 *   </Box>
 *
 * Used as the loading state for pages that fetch data on mount.
 */

import React from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface PageLoaderProps {
  /** Optional loading message */
  message?: string;
}

export default function PageLoader({ message }: PageLoaderProps) {
  const { t } = useTranslation("common");
  return (
    <Box sx={{ textAlign: "center", py: 8 }}>
      <CircularProgress size={48} />
      <Typography sx={{ mt: 2 }} color="text.secondary">
        {message ?? t("PageLoader.loading")}
      </Typography>
    </Box>
  );
}
